module.exports = __webpack_public_path__ + "static/media/supplier.03b47fe1.svg";